export default "__VITE_ASSET__BeMaiD$3__"